import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromInvitesActions from '../actions/invite.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { NotificationService, UsersService } from '@fc-core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { getErrorMessage } from '@fc-core/services/notification.utils';

@Injectable()
export class InviteEffects {
  constructor(
    private actions$: Actions,
    private usersService: UsersService,
    private dialog: MatDialog,
    private router: Router,
    private notifications: NotificationService,
  ) {}

  // todo is this depricated?
  // convertInviteToUser$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(fromInvitesActions.convertInviteToUser),
  //     switchMap(({ user }) =>
  //       this.usersService.convertInviteToUser(user).pipe(
  //         switchMap((createdUser) => {
  //           this.dialog.closeAll();
  //           this.router.navigate(['/users/main/users/', createdUser.id]);
  //           return [
  //             fromInvitesActions.convertInviteToUserSuccess({
  //               user: createdUser,
  //               inviteId: +user.id,
  //             }),
  //             fromUserActions.addEmployeeSuccess({ employee: createdUser }),
  //           ];
  //         }),
  //         catchError((error) => of(fromInvitesActions.invitesError({ error }))),
  //       ),
  //     ),
  //   ),
  // );

  loadInvites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromInvitesActions.loadInvites),
      switchMap(() =>
        this.usersService.loadInvites().pipe(
          map(({ list, count }) => {
            return fromInvitesActions.loadInvitesSuccess({
              invites: list,
              count,
            });
          }),
          catchError((error) => of(fromInvitesActions.invitesError({ error }))),
        ),
      ),
    ),
  );

  addInvite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromInvitesActions.addInvite),
      switchMap(({ invite }) =>
        this.usersService.sendInvitation(invite).pipe(
          map(() => {
            this.notifications.showSuccess('Invite successfully sent');
            this.dialog.closeAll();
            return fromInvitesActions.loadInvites();
          }),
          catchError((error) => of(fromInvitesActions.invitesError({ error }))),
        ),
      ),
    ),
  );

  deleteInvite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromInvitesActions.deleteInvite),
      switchMap(({ inviteId }) =>
        this.usersService.deleteInvite(inviteId).pipe(
          map(() => {
            this.notifications.showSuccess('Invite successfully deleted');
            this.dialog.closeAll();
            return fromInvitesActions.deleteInviteSuccess({ inviteId });
          }),
          catchError((error) => of(fromInvitesActions.invitesError({ error }))),
        ),
      ),
    ),
  );

  resendInvite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromInvitesActions.resendInvite),
      switchMap(({ inviteId, employee }) =>
        this.usersService.resendInvitation(inviteId, employee).pipe(
          map(() => {
            this.notifications.showSuccess('Invite successfully resended');
            this.dialog.closeAll();
            return fromInvitesActions.resendInviteSuccess();
          }),
          catchError((error) => of(fromInvitesActions.invitesError({ error }))),
        ),
      ),
    ),
  );

  invitesError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromInvitesActions.invitesError),
        switchMap((error) => {
          this.notifications.showError(getErrorMessage(error?.error));
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );
}
